/**
 * Search widget component.
 * @module components/theme/SearchWidget/SearchWidget
 */

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { PropTypes } from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import webcamSVG from 'volto-deba/../theme/site/assets/images/i_webcam.svg';
import { Icon } from '@plone/volto/components';
import zoomSVG from '@plone/volto/icons/zoom.svg';
import { Image } from 'semantic-ui-react';
import { UniversalLink } from '@plone/volto/components';

const messages = defineMessages({
  search: {
    id: 'Search',
    defaultMessage: 'Search',
  },
  searchSite: {
    id: 'Search Site',
    defaultMessage: 'Search Site',
  },
  webcam: {
    id: 'webcam',
    defaultMessage: 'Webcam',
  },
});

/**
 * SearchWidget component class.
 * @class SearchWidget
 * @extends Component
 */
class SearchWidget extends Component {
  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  static propTypes = {
    pathname: PropTypes.string,
  };

  /**
   * Constructor
   * @method constructor
   * @param {Object} props Component properties
   * @constructs WysiwygEditor
   */
  constructor(props) {
    super(props);
    this.onChangeText = this.onChangeText.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      text: '',
      lang: this.props.location.pathname.split('/')[1],
    };
  }
  /**
   * On change text
   * @method onChangeText
   * @param {object} event Event object.
   * @param {string} value Text value.
   * @returns {undefined}
   */
  onChangeText(event, { value }) {
    this.setState({
      text: value,
    });
  }

  /**
   * Submit handler
   * @method onSubmit
   * @param {event} event Event object.
   * @returns {undefined}
   */
  onSubmit(event) {
    const path =
      this.props.pathname?.length > 0
        ? `&path=${encodeURIComponent(this.props.pathname)}`
        : '';
    this.props.history.push(
      `/search?SearchableText=${encodeURIComponent(this.state.text)}${path}`,
    );
    event.preventDefault();
  }

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    const lang = this.state.lang;
    let link = '';
    switch (lang) {
      case 'en':
        link = link.concat('/en/tourism/searcher');
        break;
      case 'fr':
        link = link.concat('/fr/tourisme/rechercher');
        break;
      case 'eu':
        link = link.concat(`/${lang}`);
        this.props.subsite &&
          (link = link.concat(`/${this.props.subsite?.title?.toLowerCase()}`));
        link = link.concat('/bilaketa');
        break;
      case 'es':
        link = link.concat(`/${lang}`);
        this.props.subsite &&
          (link = link.concat(`/${this.props.subsite?.title?.toLowerCase()}`));

        link = link.concat('/buscador');
        break;
      //no default
    }
    const webcamurl =
      'https://www.gipuzkoa.eus/eu/web/ingurumena/hondartzak/web-kamerak/deba';
    return (
      <>
        {!this.props.subsite && (
          <a className="top-webcam" href={webcamurl}>
            {/* {this.props.intl.formatMessage(messages.webcam)} */}
            {/* <Link
            className="top-webcam"
            to={flattenToAppURL(webcamurl)}
            title={this.props.intl.formatMessage(messages.webcam)}
          > */}
            <Image
              src={webcamSVG}
              alt={this.props.intl.formatMessage(messages.webcam)}
              width="20"
              height="20"
            />
            {this.props.intl.formatMessage(messages.webcam)}
            {/* </Link> */}
          </a>
        )}
        <UniversalLink
          className="top-search"
          href={`${link}`}
          title={this.props.intl.formatMessage(messages.search)}
        >
          <Icon name={zoomSVG} size="18px" />
          {this.props.intl.formatMessage(messages.search)}
        </UniversalLink>
      </>
    );
  }
}

export default compose(
  withRouter,
  injectIntl,
  connect((state) => ({
    subsite: state.subsite?.data,
  })),
)(SearchWidget);
